module.exports = __webpack_public_path__ + "img/picture9.844ba826.png";